import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Carousel from '../components/Carousel';
import Button from '../components/Button';
import { useI18n } from '../i18n/LanguageProvider';

const ServiceDetail = () => {
  const { services, t } = useI18n();
  const { slug } = useParams();
  const svc = services.find(s => s.slug === slug);

  if (!svc) {
    return (
      <section className="section">
        <div className="container">
          <h1>{t('serviceDetail.notFound')}</h1>
          <Link to="/services"><Button variant="primary">{t('serviceDetail.back')}</Button></Link>
        </div>
      </section>
    );
  }

  return (
    <section className="section service-detail">
      <div className="container grid-2 service-detail__container">
        <div className="route-enter">
          {/* controls ON on detail page */}
          <Carousel images={svc.images} alt={svc.title} showControls={true} />
        </div>
        <div className="route-enter service-detail__content">
          <h1>{svc.title}</h1>
          <p className="muted">{svc.short}</p>
          <div className="service-detail__text mt-2">
            {svc.intro && <p>{svc.intro}</p>}
            {svc.description && svc.description.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          {Array.isArray(svc.bullets) && svc.bullets.length > 0 && (
            <ul className="service-detail__list mt-2">
              {svc.bullets.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
          <p className="muted mt-1"><em>{svc.priceNote}</em></p>
          <div className="service-detail__actions mt-2">
            {/* Передаём preselect через state + дублируем в query на всякий случай */}
            <Link
              to={`/booking?service=${encodeURIComponent(svc.slug)}`}
              state={{ preselect: svc.slug }}
            >
              <Button variant="primary">{t('serviceDetail.bookThis')}</Button>
            </Link>
            <Link to="/services"><Button variant="ghost">{t('serviceDetail.allServices')}</Button></Link>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ServiceDetail;
